import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-ng-select',
    template: `
        <div class="form-group">
            <ng-select
                [items]="to.options"
                [clearable]="!to.required"
                [bindValue]="to.valueProp || 'value'"
                [multiple]="to.multiple || false"
                [formControl]="formControl"
                appendTo="body"
            >
                <ng-template ng-label-tmp let-item="item">
                    <span
                        [innerHTML]="
                            item ? item[to.labelProp ?? 'label'] : undefined
                        "
                    ></span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                    <span
                        [innerHTML]="
                            item ? item[to.labelProp ?? 'label'] : undefined
                        "
                    ></span>
                </ng-template>
            </ng-select>
        </div>
    `
})
export class FormlyNgSelect extends FieldType {}
